import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { useModals } from "ModalProvider";
import { useContext } from "react";
import { GTMProjectContext } from "../GTMProjectContext";
import PackagingBaseInfoForm from "./PackagingBaseInfoForm";
import GTMProjectPackagingDataView from "./GTMProjectPackagingDataView";

const PackagingViews = () => {
  const { originalGTMProject, saveProject, saveProjectRes } =
    useContext(GTMProjectContext);

  const packagings = originalGTMProject.packagings;

  const modal = useModals();

  function createPackaging() {
    modal.present({
      title: "Create Packaging",
      children: (
        <PackagingBaseInfoForm
          gtmProjectId={originalGTMProject.id}
          onSave={modal.hide}
        />
      ),
    });
  }

  function confirmHandler() {
    if (window.confirm("Are you sure you want to confirm the packagings?")) {
      saveProject({
        variables: {
          id: originalGTMProject.id,
          packagingConfirmedAt: new Date().toISOString(),
        },
        onCompleted() {
          Alert("success", "Packagings confirmed.");
        },
      });
    }
  }

  const disabled = originalGTMProject.packagingConfirmedAt;

  return (
    <div className="card relative">
      <h5>
        Packagings (
        <b className="text-orange-500">
          {originalGTMProject.marketingManager.firstName}
        </b>
        )
      </h5>
      <div className="opacity-70">
        Create packagings, input all the required information we need. Review
        and confirm.
      </div>

      {!originalGTMProject.marketingManager?.id && (
        <div className="font-bold text-pink-600 mt-2">
          Please set a responsible user for Packaging Information first.
        </div>
      )}

      {originalGTMProject.marketingManager?.id && (
        <>
          {originalGTMProject.packagingConfirmedAt && (
            <div className="text-green-600 font-bold mt-1">
              🟢 Confirmed at{" "}
              {new Date(
                originalGTMProject.packagingConfirmedAt,
              ).toLocaleString()}
              .
            </div>
          )}

          {packagings.length > 0 && (
            <div className="space-y-16 mt-4">
              {packagings.map((pkg, index) => (
                <GTMProjectPackagingDataView
                  key={pkg.id}
                  pkg={pkg}
                  index={index}
                  onDelete={() => onDeletePackaging(index)}
                  updatePkg={(values) =>
                    updatePkg({ ...pkg, ...values }, index)
                  }
                  disabled={disabled}
                />
              ))}
            </div>
          )}

          {!originalGTMProject.packagingConfirmedAt && (
            <div>
              <hr />

              <div className="flex space-x-4 justify-between">
                <Button disabled={disabled} onClick={createPackaging}>
                  + Create New Packaging
                </Button>
              </div>

              <hr />

              <div className="mt-4">
                <div className="opacity-70 text-right text-xs">
                  Once you have filled and checked in all information above, you
                  can confirm the packagings.
                </div>

                <div className="flex justify-end">
                  <Button
                    disabled={packagings.length === 0}
                    onClick={confirmHandler}
                    loading={saveProjectRes.loading}
                  >
                    Confirm All Packagings Information
                  </Button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PackagingViews;
